/**
 * Zondela Header Destinations
 * Desktop: hover/click to open mega menu panels (one per region + "all").
 * Mobile: accordion — "Destinos" expands to a list of regions, each
 * expandable into a vertical list of destination cards.
 * Re-initializes on `shopify:section:load` for the theme editor.
 */
(function () {
  function closeAllPanels(root, except) {
    root.querySelectorAll('[data-zhd-item][data-open]').forEach(function (item) {
      if (item === except) return;
      item.removeAttribute('data-open');
      var trigger = item.querySelector('[data-zhd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initDesktop(root) {
    var items = root.querySelectorAll('[data-zhd-item]');
    var closeTimer = null;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-zhd-trigger]');
      if (!trigger) return;

      function open() {
        clearTimeout(closeTimer);
        closeAllPanels(root, item);
        item.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        item.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (item.hasAttribute('data-open')) {
          close();
        } else {
          open();
        }
      });

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) open();
      });

      item.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        closeTimer = setTimeout(close, 150);
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAllPanels(root, null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllPanels(root, null);
    });
  }

  function initMobile(root) {
    var mobile = root.querySelector('[data-zhd-mobile]');
    if (!mobile) return;

    var trigger = mobile.querySelector('[data-zhd-mobile-trigger]');
    var panel = mobile.querySelector('[data-zhd-mobile-panel]');

    if (trigger && panel) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
    }

    mobile.querySelectorAll('[data-zhd-accordion-trigger]').forEach(function (accTrigger) {
      var accPanel = accTrigger.nextElementSibling;
      accTrigger.addEventListener('click', function () {
        var expanded = accTrigger.getAttribute('aria-expanded') === 'true';
        accTrigger.setAttribute('aria-expanded', String(!expanded));
        if (accPanel) accPanel.hidden = expanded;
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-zhd]').forEach(function (section) {
      if (section.dataset.zhdInitialized === 'true') return;
      section.dataset.zhdInitialized = 'true';
      initDesktop(section);
      initMobile(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-zhd]');
    if (section) init(event.target);
  });
})();
